// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper_stub-3QI_r";
var _4 = "gradient-1dVmI";
var _5 = "longTrip-3wThr";
var _6 = "order__info-Qt6sk";
var _7 = "button__download-3YGUL";
var _8 = "card__content-3vEBM";
var _9 = "city__stub-dH5rR";
var _a = "ids-2Wcp5";
var _b = "ids__row-13Mnl";
var _c = "ids__row__title-CaJzj";
var _d = "ids__row__value-1vjUM";
var _e = "departure-3YpNL";
var _f = "arrival-1lw0A";
var _10 = "arrival_mediumFont-1d7fc";
var _11 = "arrival_smallFont-3TJVU";
var _12 = "manage-1nOex";
var _13 = "button-1KRx-";
var _14 = "button__view-1RhpS";
var _15 = "card__content_paid-3xuV3";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper_stub", _4 as "gradient", _5 as "longTrip", _6 as "order__info", _7 as "button__download", _8 as "card__content", _9 as "city__stub", _a as "ids", _b as "ids__row", _c as "ids__row__title", _d as "ids__row__value", _e as "departure", _f as "arrival", _10 as "arrival_mediumFont", _11 as "arrival_smallFont", _12 as "manage", _13 as "button", _14 as "button__view", _15 as "card__content_paid" }
export default { "__esModule": _1, "mobile": _2, "wrapper_stub": _3, "gradient": _4, "longTrip": _5, "order__info": _6, "button__download": _7, "card__content": _8, "city__stub": _9, "ids": _a, "ids__row": _b, "ids__row__title": _c, "ids__row__value": _d, "departure": _e, "arrival": _f, "arrival_mediumFont": _10, "arrival_smallFont": _11, "manage": _12, "button": _13, "button__view": _14, "card__content_paid": _15 }
